import { createSlice } from "@reduxjs/toolkit"
import { INSTAGRAM_AGENT_ANALYTICS } from "../../../../constants/reducer_names"

const initialState = {
    checked_column: [
        "Agent Name",
        "Received Chats",
        "Responded Chats",
        "Abandoned Chats",
        "Missed Chats",
        "Transferred Chats",
        "Total chat duration",
        "Avg. chat duration",
        "Interactions from Customer",
        "Interactions from Agent",
        "Total Interactions"
    ] as any,
    checked_column2: [
        "Agent Name",
        "Agent Idle time",
        "Avg. Response Time",
        "Avg. Handle Time (AHT)",
        "Maximum Handle Time",
        "Total ACW Time",
        "Avg. Hold Time",
        "Avg. Queue Wait Time",
        "Maximum Queue Wait Time",
        "Occupancy Rate (%)",
        "First Chat Resolution (%)",
        "Customer Satisfaction (%)"
    ] as any,
    checked_column3: [
        "Agent Name",
        "Chat Type",
        "SL1",
        "SL2",
        "SL3",
        "SL4",
        "SL5",
        "SL6",
        "Total",
        "Missed Chats",
        "SLA Achieved (%)",
        "SLA Breached (%)"
    ] as any,
    titleMapper_ForDb: {
        "Agent Name":"agentName",
        "Received Chats":"receivedChat",
        "Responded Chats":"respondedChat",
        "Abandoned Chats":"abandonedChat",
        "Missed Chats":"missedChat",
        "Transferred Chats":"transferredChat",
        "Total chat duration":"TotalChatDuration",
        "Avg. chat duration":"AverageChatDuration",
        "Interactions from Customer":"InteractionWithCustomer",
        "Interactions from Agent":"InteractionWithAgent",
        "Total Interactions":"totalInteraction"
    } as any,
    titleMapper_ForDb2: {
        "Agent Name":"agentName",
        "Agent Idle time":"AgentIdleTime",
        "Avg. Response Time":"averageResponseTime",
        "Avg. Handle Time (AHT)":"averageHandledTime",
        "Maximum Handle Time":"MaximumHandledTime",
        "Total ACW Time":"totalACWTime",
        "Avg. Hold Time":"averageHoldtime",
        "Avg. Queue Wait Time":"averageQueueWaitingtime",
        "Maximum Queue Wait Time":"maximumQueueWaitingtime",
        "Occupancy Rate (%)":"occupancyrate",
        "First Chat Resolution (%)":"firstChatResolution",
        "Customer Satisfaction (%)":"CustomerSatisfaction",
    } as any,
    titleMapper_ForDb3: {
        "Agent Name": "agentName",
        "Chat Type": "ChatType",
        "SL1": "SL1",
        "SL2": "SL2",
        "SL3": "SL3",
        "SL4": "SL4",
        "SL5": "SL5",
        "SL6": "SL6",
        "Total": "Total",
        "Missed Chats": "MissedChats",
        "SLA Achieved (%)": "SLAAchieved",
        "SLA Breached (%)": "SLABreached"
    } as any,
    updated_TableColumn: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },

        {
            title: 'Received Chats',
            dataIndex: 'receivedChat',
            key: 'receivedChat',
        },
        {
            title: 'Responded Chats',
            dataIndex: 'respondedChat',
            key: 'respondedChat',
        },
        {
            title: 'Abandoned Chats',
            dataIndex: 'abandonedChat',
            key: 'abandonedChat',
        },
        {
            title: 'Missed Chats',
            dataIndex: 'missedChat',
            key: 'missedChat',
        },
        {
            title: 'Transferred Chats',
            dataIndex: 'transferredChat',
            key: 'transferredChat',
        },
        {
            title: 'Total chat duration',
            dataIndex: 'TotalChatDuration',
            key: 'TotalChatDuration',
        },
        {
            title: 'Avg. chat duration',
            dataIndex: 'AverageChatDuration',
            key: 'AverageChatDuration',
        },
        {
            title: 'Interactions from Customer',
            dataIndex: 'InteractionWithCustomer',
            key: 'InteractionWithCustomer',
        },
        {
            title: 'Interactions from Agent',
            dataIndex: 'InteractionWithAgent',
            key: 'InteractionWithAgent',
        },
        {
            title: 'Total Interactions',
            dataIndex: 'totalInteraction',
            key: 'totalInteraction',
        }
    ] as any,
    updated_TableColumn2: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Agent Idle time',
            dataIndex: 'AgentIdleTime',
            key: 'AgentIdleTime',
        },
        {
            title: 'Avg. Response Time',
            dataIndex: 'averageResponseTime',
            key: 'averageResponseTime',
        },
        {
            title: 'Avg. Handle Time (AHT)',
            dataIndex: 'averageHandledTime',
            key: 'averageHandledTime',
        },
        {
            title: 'Maximum Handle Time',
            dataIndex: 'MaximumHandledTime',
            key: 'MaximumHandledTime',
        },
        {
            title: 'Total ACW Time',
            dataIndex: 'totalACWTime',
            key: 'totalACWTime',
        },
        {
            title: 'Avg. Hold Time',
            dataIndex: 'averageHoldtime',
            key: 'averageHoldtime',
        },
        {
            title: 'Avg. Queue Wait Time',
            dataIndex: 'averageQueueWaitingtime',
            key: 'averageQueueWaitingtime',
        },
        {
            title: 'Maximum Queue Wait Time',
            dataIndex: 'maximumQueueWaitingtime',
            key: 'maximumQueueWaitingtime',
        },
        {
            title: 'Occupancy Rate (%)',
            dataIndex: 'occupancyrate',
            key: 'occupancyrate',
        },
        {
            title: 'First Chat Resolution (%)',
            dataIndex: 'firstChatResolution',
            key: 'firstChatResolution',
        },
        {
            title: 'Customer Satisfaction (%)',
            dataIndex: 'CustomerSatisfaction',
            key: 'CustomerSatisfaction',
        }
    ] as any,
    updated_TableColumn3: [
        {
            title: 'Agent Name',
            dataIndex: 'agentName',
            key: 'agentName',
        },
        {
            title: 'Chat Type',
            dataIndex: 'ChatType',
            key: 'ChatType',
        },
        {
            title: 'SL1',
            dataIndex: 'SL1',
            key: 'SL1',
        },
        {
            title: 'SL2',
            dataIndex: 'SL2',
            key: 'SL2',
        },
        {
            title: 'SL3',
            dataIndex: 'SL3',
            key: 'SL3',
        },
        {
            title: 'SL4',
            dataIndex: 'SL4',
            key: 'SL4',
        },
        {
            title: 'SL5',
            dataIndex: 'SL5',
            key: 'SL5',
        },
        {
            title: 'SL6',
            dataIndex: 'SL6',
            key: 'SL6',
        },
        {
            title: 'Total',
            dataIndex: 'Total',
            key: 'Total',
        },
        {
            title: 'Missed Chats',
            dataIndex: 'MissedChats',
            key: 'MissedChats',
        },
        {
            title: 'SLA Achieved (%)',
            dataIndex: 'SLAAchieved',
            key: 'SLAAchieved',
        },
        {
            title: 'SLA Breached (%)',
            dataIndex: 'SLABreached',
            key: 'SLABreached',
        },
    ] as any
}

const agentAnalyticsInstagramSlice = createSlice({
    name: INSTAGRAM_AGENT_ANALYTICS,
    initialState,
    reducers: {
        checkedColumn: (state, { payload }) => {
            state.checked_column = payload.checked_column;
        },
        checkedColumn2: (state, { payload }) => {
            state.checked_column2 = payload.checked_column2;
        },
        checkedColumn3: (state, { payload }) => {
            state.checked_column3 = payload.checked_column3;
        },
        titleMapperForDb: (state, { payload }) => {
            state.titleMapper_ForDb = payload.titleMapper_ForDb;
        },
        titleMapperForDb2: (state, { payload }) => {
            state.titleMapper_ForDb2 = payload.titleMapper_ForDb2;
        },
        titleMapperForDb3: (state, { payload }) => {
            state.titleMapper_ForDb3 = payload.titleMapper_ForDb3;
        },
        updatedTableColumn: (state, { payload }) => {
            state.updated_TableColumn = payload.updated_TableColumn;
        },
        updatedTableColumn2: (state, { payload }) => {
            state.updated_TableColumn2 = payload.updated_TableColumn2;
        },
        updatedTableColumn3: (state, { payload }) => {
            state.updated_TableColumn3 = payload.updated_TableColumn3;
        },


    }
})

export const agentAnalyticsInstagramSliceActions = agentAnalyticsInstagramSlice.actions;
export const agentAnalyticsInstagramReducer = agentAnalyticsInstagramSlice.reducer